import { useQuery } from '@tanstack/react-query';

import TaxonomiesService from '@/services/TaxonomiesService';

export const GET_TAXONOMIES_BY_VERSION_AND_CATEGORY_QUERY_KEY = (
  version: string,
  category: string,
) => ['taxonomy', version, category];

export function useGetTaxonomiesByVersionAndCategory(
  version: string,
  category: string,
) {
  const { data, isFetching } = useQuery({
    queryKey: GET_TAXONOMIES_BY_VERSION_AND_CATEGORY_QUERY_KEY(
      version,
      category,
    ),
    queryFn: () =>
      TaxonomiesService.getTaxonomyPropertiesByVersionAndCategory(
        version,
        category,
      ),
    enabled: !!version && !!category && !(category === ''),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  const formattedData = data ?? [];

  return {
    properties: formattedData,
    propertiesLoading: isFetching,
  };
}
